import React, { useState, useEffect } from "react";
import Header from "components/Headers/Header.js";
import { useHistory } from "react-router-dom";
import {
  Badge,
  Card,
  CardHeader,
  NavItem,
  NavLink,
  Nav,
  Row,
  Col,
} from "reactstrap";
import classnames from "classnames";
import { DataTable, FilterBar } from "components/shared";

import { UNIT_PEPORT, MANUAL_PEPORT } from "../../../services/CONSTANTS";
import { getApiDataService } from "../../../services/apiServices";
import moment from "moment";
import DateRangePicker from "react-bootstrap-daterangepicker";

const COLUMNS = [
  { key: "index", label: "#", className: "text-center" },
  { key: "itemName", label: "Item Name", className: "text-center" },
  { key: "orderCount", label: "Order Count", className: "text-center" },
  { key: "totalUnit", label: "Total Unit", className: "text-center" },
  { key: "totalOriginalUnit", label: "Total Original Unit", className: "text-center" },
  { key: "totalCurrency", label: "Total Currency", className: "text-center" },
];

function ItemReport() {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);

  const [item, setitem] = useState(null);

  const [activeNav, setActiveNav] = useState(1);
  const [game, setGame] = useState("Myanmar");

  let start = moment().startOf("day").toISOString();
  let end = moment().endOf("day").toISOString();
  const [startDate, setStartDate] = useState(start);
  const [endDate, setEndDate] = useState(end);

  const [reports, setReports] = useState([]);
  const [gameId, setGameId] = useState("649ef8db2f7c0933b90549f8");
  const [api, setApi] = useState("normal");
  const [region, setRegion] = useState(null)

  const [dateChangeEvent, setDateChangeEvent] = useState(true)

  useEffect(() => {
    fetchItemReport();
  }, [gameId, api, dateChangeEvent, region]);

  const fetchItemReport = () => {
    setIsLoading(true);
    let url = UNIT_PEPORT(gameId) + `?api=${api}&start_date=${startDate}&end_date=${endDate}`
    url += region ? `&region=${region}` : '';
    if (api == "manual") {
      url = MANUAL_PEPORT(gameId) + `?start_date=${startDate}&end_date=${endDate}`
    }
    getApiDataService(url)
      .then((res) => {
        setReports(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("Error in useEffect!", err);
        setIsLoading(false);
        setReports([]);
      });
    return () => {
      console.log("axios cleanup.");
    };
  };

  const toggleNavs = (e, index, val) => {
    e.preventDefault();
    setActiveNav(index);
    setGameId(val);
    setApi('normal')
  };

  const apiChooseHandler = (e, name) => {
    e.preventDefault();
    setApi(name);
  };

  const handleCallback = (start, end, label) => {
    console.log(start.toISOString(), "startDate1");
    console.log(end.toISOString(), "EndDate2");
    // moment('2020-06-05').format('YYYY-MM-DDTHH:mm:ssZ')
    setStartDate(start.toISOString());
    setEndDate(end.toISOString());

    setDateChangeEvent(!dateChangeEvent)
  };

  return (
    <>
      <Card className="shadow">
        <CardHeader className="border-0">
          <FilterBar title="Daily Orders Report">
            <Nav className="justify-content-end" pills>
                <NavItem>
                  <NavLink
                    className={classnames("py-2 px-3", {
                      active: activeNav === 4,
                    })}
                    href="#pablo"
                    onClick={(e) => {
                      toggleNavs(e, 4, "36d43de8-0cf1-4a25-a7b1-64bcfcab7044")
                      setApi('smileone')
                    }
                    }
                  >
                    <span className="d-none d-md-block">MGG</span>
                    <span className="d-md-none">M</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames("py-2 px-3", {
                      active: activeNav === 1,
                    })}
                    href="#pablo"
                    onClick={(e) =>
                      toggleNavs(e, 1, "649ef8db2f7c0933b90549f8")
                    }
                  >
                    <span className="d-none d-md-block">ML</span>
                    <span className="d-md-none">M</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames("py-2 px-3", {
                      active: activeNav === 2,
                    })}
                    data-toggle="tab"
                    href="#pablo"
                    onClick={(e) =>
                      toggleNavs(e, 2, "649ef8db2f7c0933b90549f7")
                    }
                  >
                    <span className="d-none d-md-block">PUBG</span>
                    <span className="d-md-none">T</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames("py-2 px-3", {
                      active: activeNav === 3,
                    })}
                    data-toggle="tab"
                    href="#pablo"
                    onClick={(e) =>
                      toggleNavs(e, 3, "649ef8db2f7c0933b90549f6")
                    }
                  >
                    <span className="d-none d-md-block">LOL</span>
                    <span className="d-md-none">0</span>
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    className={classnames("py-2 px-3", {
                      active: activeNav === 3,
                    })}
                    data-toggle="tab"
                    href="#pablo"
                    onClick={(e) =>
                      toggleNavs(e, 3, "6635220cec4a25ec7150c816")
                    }
                  >
                    <span className="d-none d-md-block">HOK</span>
                    <span className="d-md-none">0</span>
                  </NavLink>
                </NavItem>
            </Nav>
            <DateRangePicker onCallback={handleCallback}>
              <input
                style={{ width: "200px" }}
                className="form-control"
                placeholder="Select date range"
                aria-label="Date range"
              />
            </DateRangePicker>
          </FilterBar>
          {gameId == "649ef8db2f7c0933b90549f8" && (
            <Row className="align-items-end mt-3">
              <div className="col">
                <Nav className="justify-content-end" pills>
                  <NavItem>
                    <NavLink
                      className={classnames("py-2 px-3", {
                        active: api === "prepaidcard",
                      })}
                      data-toggle="tab"
                      href="#pablo1"
                      onClick={(e) => apiChooseHandler(e, "prepaidcard")}
                    >
                      <span className="d-none d-md-block">PrepaidCard API</span>
                      <span className="d-md-none">T</span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames("py-2 px-3", {
                        active: api === "smileone",
                      })}
                      data-toggle="tab"
                      href="#pablo1"
                      onClick={(e) => apiChooseHandler(e, "smileone")}
                    >
                      <span className="d-none d-md-block">SmileOne API</span>
                      <span className="d-md-none">0</span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames("py-2 px-3", {
                        active: api === "normal",
                      })}
                      href="#pablo1"
                      onClick={(e) => apiChooseHandler(e, "normal")}
                    >
                      <span className="d-none d-md-block">Normal</span>
                      <span className="d-md-none">M</span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames("py-2 px-3", {
                        active: api === "manual",
                      })}
                      href="#pablo1"
                      onClick={(e) => apiChooseHandler(e, "manual")}
                    >
                      <span className="d-none d-md-block">POS</span>
                      <span className="d-md-none">M</span>
                    </NavLink>
                  </NavItem>
                </Nav>
              </div>
            </Row>
          )}

          {
            gameId == '649ef8db2f7c0933b90549f7' && (
              <Row className="align-items-end mt-3">
                <div className="col">
                  <Nav className="justify-content-end" pills>
                    <NavItem>
                      <NavLink
                        className={classnames("py-2 px-3", {
                          active: region === "Myanmar",
                        })}
                        data-toggle="tab"
                        onClick={(e) => setRegion("Myanmar")}
                      >
                        <span className="d-none d-md-block">Myanmar</span>
                        <span className="d-md-none">0</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames("py-2 px-3", {
                          active: region === "Thai",
                        })}
                        onClick={(e) => setRegion("Thai")}
                      >
                        <span className="d-none d-md-block">Thai</span>
                        <span className="d-md-none">M</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames("py-2 px-3", {
                          active: region === "Other",
                        })}
                        onClick={(e) => setRegion("Other")}
                      >
                        <span className="d-none d-md-block">Global</span>
                        <span className="d-md-none">M</span>
                      </NavLink>
                    </NavItem>
                  </Nav>
                </div>
              </Row>
            )
          }
        </CardHeader>
        <DataTable
          columns={COLUMNS}
          data={reports}
          isLoading={isLoading}
          emptyMessage="No records found"
          renderRow={(item, index) => (
            <tr key={item?.item_name ?? index}>
              <th className="text-center" scope="row">
                {index + 1}
              </th>
              <th className="text-center" scope="row">
                {item?.item_name} <br />
                <Badge color="primary" pill className="font-mono">
                  {item?.unit_price} {item?.currency}
                </Badge>
              </th>
              <td className="text-center font-mono">
                {item?.order_count.toLocaleString("en-US")}
              </td>
              <td className="text-center font-mono">
                {item?.total_unit?.toLocaleString("en-US")}
              </td>
              <td className="text-center font-mono">
                {item?.total_original_unit?.toLocaleString("en-US")}
              </td>
              <td className="text-center font-mono">
                {item?.total_price?.toLocaleString("en-US")} {item?.currency}
              </td>
            </tr>
          )}
          footer={
            reports.length > 0 ? (
              <tr style={{ borderTop: "2px solid #1a174d" }}>
                <td></td>
                <td className="text-right bg-gradient-default shadow text-white">
                  Total :
                </td>
                <td className="text-center font-mono">
                  {reports
                    .reduce((a, b) => a + b.order_count, 0)
                    .toLocaleString("en-US")}
                </td>
                <td className="text-center font-mono">
                  {reports
                    .reduce((a, b) => a + b.total_unit, 0)
                    .toLocaleString("en-US")}
                </td>
                <td className="text-center font-mono">
                  {reports
                    .reduce((a, b) => a + b.total_original_unit, 0)
                    .toLocaleString("en-US")}
                </td>
                <td className="text-center font-mono">
                  {reports
                    .reduce(
                      (a, b) =>
                        b.currency == "MMK" ? a + b.total_price : a + 0,
                      0
                    )
                    .toLocaleString("en-US")}{" "}
                  MMK |{" "}
                  {reports
                    .reduce(
                      (a, b) =>
                        b.currency == "THB" ? a + b.total_price : a + 0,
                      0
                    )
                    .toLocaleString("en-US")}{" "}
                  THB
                </td>
              </tr>
            ) : null
          }
        />
      </Card>

    </>
  );
}

export default ItemReport;
